var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHistoryCrown = function SvgHistoryCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F54EB",
    d: "m14.056 4.32-3.04 1.874L8.1 2.304a.126.126 0 0 0-.202 0l-2.914 3.89L1.942 4.32a.126.126 0 0 0-.19.124l1.193 9.072a.254.254 0 0 0 .25.219h9.61a.25.25 0 0 0 .25-.22l1.193-9.071a.127.127 0 0 0-.192-.124M8 11.472c-.97 0-1.76-.79-1.76-1.76S7.03 7.954 8 7.954s1.759.79 1.759 1.76-.79 1.759-1.76 1.759m0-2.514A.754.754 0 1 0 8 10.466.754.754 0 0 0 8 8.958"
  })));
};
export default SvgHistoryCrown;